export default __webpack_public_path__ + "static/media/sport-img.7095e9a5.webp";